// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2iQBX","inputDescription":"styles_inputDescription__exciQ"};